<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <!-- <el-button type="primary" @click="division_add()">新增</el-button> -->
    <el-form :inline="true" v-if="buttonList != null && buttonList.length > 0" :model="filters" @submit.native.prevent
      @row-click="selectCurrentRow">
      <el-form-item label="客户名称">
        <el-input v-model="filters.Account_Short_Name__c" placeholder="请输入客户名称"></el-input>
      </el-form-item>
      <el-form-item label="门店名称">
        <el-input v-model="filters.Title" placeholder="请输入门店名称"></el-input>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input v-model="filters.Name" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="filters.Phone" onkeyup="value=value.replace(/[^\d]/g,'')" maxlength="4"
          placeholder="请输入手机号后四位"></el-input>
      </el-form-item>
      <el-form-item label="职位">
        <el-input v-model="filters.Position_pro" placeholder="请输入职位"></el-input>
      </el-form-item>
      <el-form-item label="标签名称">
        <el-input v-model="filters.TagName" placeholder="请输入标签名称"></el-input>
      </el-form-item>
      <br />
      <el-form-item label="注册日期">
        <el-date-picker v-model="filters.StartCreateTime" type="date" :editable="false" value-format="yyyy-MM-dd"
          placeholder="请选择注册日期"></el-date-picker>
        ~
        <el-date-picker v-model="filters.EndCreateTime" type="date" :editable="false" value-format="yyyy-MM-dd"
          placeholder="请选择注册日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="filters.Status" clearable placeholder="请选择状态">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="有效" value="1"></el-option>
          <el-option label="阻止" value="2"></el-option>
          <el-option label="待审核" value="0"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="学员角色">
        <el-select v-model="filters.IdentityId" clearable placeholder="请选择角色">
          <el-option label="全部" :value="0"></el-option>
          <el-option v-for="item in memberIdentityErtificates" :key="item.Id" :label="item.Name"
            :value="item.Id"></el-option>
        </el-select>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <el-button :type="item.Func &&
          (item.Func.toLowerCase().indexOf('handledel') != -1 ||
            item.Func.toLowerCase().indexOf('stop') != -1)
          ? 'danger'
          : 'primary'
          " @click="callFunc(item)">
          {{ item.name }}
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-upload ref="upload" action="/api/WebMember/MemberTagImportExcelData" :data="{}" :headers="token"
          :show-file-list="false" :on-success="handleSuccess" :before-upload="handlebefore" :on-error="handonerror"
          :file-list="fileList">
          <el-button type="primary">批量打标签</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <label style="color:red;">筛选数量：</label>
        <label>{{ total }}</label>
      </el-form-item>
    </el-form>
    <!--列表-->
    <!-- <el-button type="primary" v-if="PL_IF" @click="batchPass" :disabled="this.sels.length===0">批量审批</el-button> -->
    <el-table :data="users" highlight-current-row @current-change="selectCurrentRow" v-loading="listLoading"
      @selection-change="selsChange" style="width: 100%">
      <el-table-column prop="Identity" label="所属机构类型" sortable></el-table-column>
      <el-table-column prop="EnterpriseName" label="医院名称/企业名称/学校名称" sortable></el-table-column>
      <el-table-column prop="Account_Short_Name__c" label="客户名称" sortable></el-table-column>
      <el-table-column prop="Title" label="门店名称" sortable></el-table-column>
      <el-table-column prop="name" label="姓名" sortable></el-table-column>
      <el-table-column prop="phone" label="手机号" sortable></el-table-column>
      <el-table-column prop="position_pro" label="职位" sortable></el-table-column>
      <el-table-column prop="email" label="邮箱" sortable></el-table-column>
      <el-table-column prop="professiona" label="职称" sortable></el-table-column>
      <el-table-column prop="TagNames" label="标签" width="" sortable>
        <template slot-scope="scope">
          <el-tag v-for="item in scope.row.TagNames" :key="item.Id">
            {{ item }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="CreateTime" label="注册日期" :formatter="formatDateTime" sortable></el-table-column>
      <el-table-column prop="status" label="状态" :formatter="formatStatus" sortable></el-table-column>
      <el-table-column prop="IdentityNameStrs" label="角色" sortable></el-table-column>
      <el-table-column label="操作">
        <template scope="scope">
          <el-link @click="handleOpen(scope.row.Id, 'xq')"> 详情 </el-link> |
          <el-link @click="handleOpen(scope.row.Id, 'bj')"> 编辑 </el-link> |
          <el-link type="primary" :disabled="scope.row.status == '1' ? true : false" :style="scope.row.status == '1' ? { color: '#aba6a5 !important' } : ''
            " @click="saveMemberSaveAudit(scope.row.Id, 1)">
            通过
          </el-link>
          |
          <el-link type="primary" :disabled="scope.row.status == '2' ? true : false" :style="scope.row.status == '2' ? { color: '#aba6a5 !important' } : ''
            " @click="saveMemberSaveAudit(scope.row.Id, 2)">
            阻止
          </el-link>
          |
          <!-- <el-link @click="saveMemberSaveAudit(scope.row.Id, 2)">
            阻止
          </el-link> | -->
          <el-link @click="handleTagEdit(scope.row.Id)"> 标签 </el-link> |
          <el-link @click="handleCertificateFormEdit(scope.row.Id)">
            发放证书
          </el-link>
          |
          <el-link @click="handleRoleFormEdit(scope.row.Id)">
            分配角色
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="50" :total="total"
        style="float: right"></el-pagination>
    </el-col>
    <el-dialog title="编辑" v-model="editFormVisible_new" :visible.sync="editFormVisible_new"
      :before-close="editForm_new_close" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="180px" :rules="editFormRules" ref="editForm">
        <el-form-item label="姓名" prop="name">
          <el-input :disabled="DETAIS_IF" v-model="editForm.name" style="width: 50%" auto-complete="off"></el-input>
        </el-form-item>
        <!-- <el-row>
          <el-col :span="12"> -->
        <el-form-item label="城市">
          <el-input v-if="!isShowAddressInfo" readonly style="width: 50%" auto-complete="off"></el-input>
          <el-cascader v-if="isShowAddressInfo" v-model="editForm.address_list" :options="store_are_list"
            :props="{ value: 'text', label: 'text' }" @change="GetStoreAccount_fn" style="width: 50%">
          </el-cascader>
        </el-form-item>
        <!-- </el-col>
        </el-row> -->
        <!-- <el-row>
          <el-col :span="12"> -->
        <el-form-item label="零售商" prop="status">
          <el-select v-model="editForm.Account_Short_Name__c" placeholder="请选择" style="width: 50%"
            @change="GetStore_fn">
            <el-option v-for="item in GetStoreAccount_list" :key="item.Id" :label="item.Account_Short_Name__c"
              :value="item.Account_Short_Name__c"></el-option>
          </el-select>
        </el-form-item>
        <!-- </el-col>
          <el-col :span="12"> -->
        <el-form-item label="门店" prop="CreateTime">
          <el-select v-model="editForm.Title" placeholder="请选择" style="width: 50%" @change="SetStoreOutletnuber_fn">
            <el-option v-for="item in GetStore_list" :key="item.Id" :label="item.Title" :value="item.Title"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-col :span="12"> -->

        <!-- </el-col> -->
        <!-- </el-col>
        </el-row> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editForm_new_close">取消</el-button>
        <el-button type="primary" @click.native="editSubmit('editForm')" :loading="editLoading">
          提交
        </el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialog_title" :visible.sync="editFormVisible" v-model="editFormVisible"
      :before-close="editForm_close" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="180px" :rules="editFormRules" ref="editForm">
        <el-row>
          <el-col :span="24">
            <el-form-item label="城市">
              <el-cascader style="width: 100%" :disabled="DETAIS_IF" v-model="editForm.address_list"
                :options="store_are_list" :props="{ value: 'text', label: 'text' }" @change="GetStoreAccount_fn">
              </el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="零售商" prop="status">
              <el-select :disabled="DETAIS_IF" v-model="editForm.Account_Short_Name__c" placeholder="请选择"
                style="width: 100%" @change="GetStore_fn">
                <el-option v-for="item in GetStoreAccount_list" :key="item.Id" :label="item.Account_Short_Name__c"
                  :value="item.Account_Short_Name__c"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="门店" prop="CreateTime">
              <el-select :disabled="DETAIS_IF" v-model="editForm.Title" placeholder="请选择" style="width: 100%">
                <el-option v-for="item in GetStore_list" :key="item.Id" :label="item.Title"
                  :value="item.Title"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input :disabled="DETAIS_IF" v-model="editForm.name" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="phone">
              <el-input :disabled="DETAIS_IF" v-model="editForm.phone" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="职位" prop="position_pro">
              <el-input :disabled="DETAIS_IF" v-model="editForm.position_pro" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职称" prop="professiona">
              <el-input :disabled="DETAIS_IF" v-model="editForm.professiona" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input :disabled="DETAIS_IF" v-model="editForm.email" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书" prop="qualificationcertifica">
              <el-input :disabled="DETAIS_IF" v-model="editForm.qualificationcertifica" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="专业" prop="Major">
              <el-input :disabled="DETAIS_IF" v-model="editForm.Major" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="毕业年份" prop="graduation_year">
              <el-input :disabled="DETAIS_IF" v-model="editForm.graduation_year" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-select v-model="editForm.status" :disabled="DETAIS_IF" placeholder="请选择" style="width: 100%">
                <el-option label="阻止" :value="2"></el-option>
                <el-option label="有效" :value="1"></el-option>
                <el-option label="待审核" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册时间" prop="CreateTime">
              <el-input :disabled="DETAIS_IF" v-model="editForm.CreateTime" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="审核人" prop="AuditSysUserInfoName">
              <el-input :disabled="DETAIS_IF" v-model="editForm.AuditSysUserInfoName" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核时间" prop="AuditTime">
              <el-input :disabled="DETAIS_IF" v-model="editForm.AuditTime" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="标签" prop="Tids">
              <el-select multiple v-model="editForm.Tids" placeholder="请选择标签" :disabled="DETAIS_IF" style="width: 100%">
                <el-option :key="0" :label="'没有选择标签'" :value="0"></el-option>
                <el-option v-for="item in allTags" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editForm_close">取消</el-button>
        <!-- <el-button v-if="!DETAIS_IF" type="primary" @click.native="editSubmit('editForm')" :loading="editLoading">
          确认
        </el-button> -->
      </div>
    </el-dialog>

    <el-dialog :title="dialog_title" :visible.sync="tagFormVisible" v-model="tagFormVisible"
      :before-close="tagForm_close" :close-on-click-modal="false">
      <el-form :model="tagForm" label-width="180px" ref="tagForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input :disabled="true" v-model="tagForm.name" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="phone">
              <el-input :disabled="true" v-model="tagForm.phone" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-select v-model="tagForm.status" :disabled="true" placeholder="请选择" style="width: 100%">
                <el-option label="阻止" :value="2"></el-option>
                <el-option label="有效" :value="1"></el-option>
                <el-option label="待审核" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标签" prop="Tids">
              <el-select multiple v-model="tagForm.Tids" placeholder="请选择标签" style="width: 100%">
                <el-option :key="0" :label="'没有选择标签'" :value="0"></el-option>
                <el-option v-for="item in tags" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="tagForm_close">取消</el-button>
        <el-button type="primary" @click.native="tagSubmit('tagForm')" :loading="editLoading">
          确认
        </el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialog_title" :visible.sync="memberCertificateFormVisible" v-model="memberCertificateFormVisible"
      :before-close="memberCertificateForm_close" :close-on-click-modal="false">
      <el-form :model="memberCertificateForm" label-width="180px" :rules="memberCertificateFormRules"
        ref="memberCertificateForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input :disabled="true" v-model="memberCertificateForm.name" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="phone">
              <el-input :disabled="true" v-model="memberCertificateForm.phone" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-select v-model="memberCertificateForm.status" :disabled="true" placeholder="请选择" style="width: 100%">
                <el-option label="阻止" :value="2"></el-option>
                <el-option label="有效" :value="1"></el-option>
                <el-option label="待审核" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书" prop="CertificateId">
              <el-select v-model="memberCertificateForm.CertificateId" placeholder="请选择证书" style="width: 100%">
                <el-option v-for="item in ertificates" :key="item.Key" :label="item.Value"
                  :value="item.Key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="memberCertificateForm_close">取消</el-button>
        <el-button type="primary" @click.native="memberCertificateFormSubmit('memberCertificateForm')"
          :loading="editLoading">
          确认
        </el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialog_title" :visible.sync="memberIdentityFormVisible" v-model="memberIdentityFormVisible"
      :before-close="memberIdentityForm_close" :close-on-click-modal="false">
      <el-form :model="memberIdentityForm" label-width="180px" :rules="memberIdentityFormRules"
        ref="memberIdentityForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input :disabled="true" v-model="memberIdentityForm.name" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="phone">
              <el-input :disabled="true" v-model="memberIdentityForm.phone" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-select v-model="memberIdentityForm.status" :disabled="true" placeholder="请选择" style="width: 100%">
                <el-option label="阻止" :value="2"></el-option>
                <el-option label="有效" :value="1"></el-option>
                <el-option label="待审核" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="分配角色" prop="IdentityIdsList">
              <el-select v-model="memberIdentityForm.IdentityIdsList" placeholder="请选择角色" multiple style="width: 100%">
                <el-option v-for="item in memberIdentityErtificates" :key="item.Id" :label="item.Name"
                  :value="item.Id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="memberIdentityForm_close">取消</el-button>
        <el-button type="primary" @click.native="memberIdentityFormSubmit('memberIdentityForm')" :loading="editLoading">
          确认
        </el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from '../../../util/date'
import {
  MemberGetList,
  MemberSaveAudit,
  MemberGet,
  MemberTagPut,
  getTagListPage,
  getAllTagListPage,
  GetMemberAllTag,
  CertificateId_GetList,
  IdentityId_GetList,
  GiveMemberCertificate,
  GetStoreAre,
  GetStoreAccount,
  GetStore,
  UpdatePut,
  GiveMemberIdentity,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'

export default {
  components: { Toolbar },
  data() {
    return {
      editFormVisible_new: false,
      GetStore_list: [],
      GetStoreAccount_list: [],
      store_are_list: [],
      tags: [],
      allTags: [],
      fileList: [],
      token: {},
      DETAIS_IF: true,
      READ: true,
      READ_IF: true,
      UPLoad_IF: true,
      UPLoad_IF_Show: false,
      isShowHide: false,
      couponId: 0,
      tagForm: {},
      tagFormVisible: false,
      dialog_title: '',
      editLoading: false,
      editForm: {},
      editFormRules: {},
      editFormVisible: false,
      editFormVisible_class: false,
      editFormVisible_jl: false,
      buttonList: [],
      managercode_list: [],
      currentRow: null,
      PL_IF: true,
      filters: {
        Account_Short_Name__c: '',
        Title: '',
        TagName: '',
        StartCreateTime: '',
        EndCreateTime: '',
        Name: '',
        Status: -1,
        IdentityId: 0,
      },
      users: [],
      users_dialog: [],
      users_dialog_jl: [],
      total: 0,
      total_dialog: 0,
      page: 1,
      page_dialog: 1,
      page_dialog_jl: 1,
      banner_imageUrl: '',
      isShowAddressInfo: true,
      memberIdentityForm: {},
      memberIdentityFormVisible: false,
      memberIdentityErtificates: [],
      memberIdentityFormRules: {
        IdentityId: [
          { required: true, message: '请选择角色', trigger: 'blur' },
        ],
      },
      memberCertificateForm: {},
      memberCertificateFormVisible: false,
      ertificates: [],
      memberCertificateFormRules: {
        CertificateId: [
          { required: true, message: '请选择证书', trigger: 'blur' },
        ],
      },
      listLoading: false,
      sels: [], //列表选中列
      TencentMeetingNumber_if: false,
    }
  },
  methods: {
    async SetStoreOutletnuber_fn(obj) {
      this.GetStore_list.forEach((element) => {
        if (element.Title == obj) {
          this.editForm.Outletnumber__c = element.Outletnumber__c
        }
      })
    },
    async GetStore_fn(nclear) {
      if (!this.editForm.address_list) {
        return
      }
      const { data } = await GetStore({
        Province: this.editForm.address_list[0],
        City: this.editForm.address_list[1],
        Area: this.editForm.address_list[2],
        Account_Short_Name__c: this.editForm.Account_Short_Name__c,
      })
      this.GetStore_list = data.response
      if (!nclear) this.editForm.Title = this.GetStore_list[0].Title
      console.log(this.GetStore_list)
    },
    async GetStoreAccount_fn() {
      if (!this.editForm.address_list) {
        return
      }
      const { data } = await GetStoreAccount({
        Province: this.editForm.address_list[0],
        City: this.editForm.address_list[1],
        Area: this.editForm.address_list[2],
      })
      this.GetStoreAccount_list = data.response
      this.editForm.Province = this.editForm.address_list[0]
      this.editForm.City = this.editForm.address_list[1]
      this.editForm.Area = this.editForm.address_list[2]
    },
    handleAvatarSuccess(res, file) {
      console.log(file)
      if (file.response.success) {
        this.banner_imageUrl = URL.createObjectURL(file.raw)
        this.editForm.BackGroundPicTureLink = file.response.response
      } else {
        this.$message({
          message: file.response.msg,
          type: 'error',
        })
      }
    },
    link_class() {
      this.MemberGetList()
      this.page_dialog = 1
      this.editFormVisible_class = true
    },
    selsChange: function (value) {
      this.sels = value
    },
    async editSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let data
          data = await UpdatePut(this.editForm)
          if (data.data.success) {
            this.editFormVisible_new = false
            this.$message({
              message: data.data.msg,
              type: 'success',
            })
            this.getModules_search()
            this.editForm = {}
          }
        } else {
          return false
        }
      })
    },
    handleAdd() {
      this.editFormVisible = true
      this.dialog_title = '新增'
      this.DETAIS_IF = false
      this.banner_imageUrl = ''
    },
    editForm_close() {
      this.editFormVisible = false
      this.editForm = {}
    },
    editForm_new_close() {
      this.editFormVisible_new = false
      this.editForm = {}
    },
    tagForm_close() {
      this.tagFormVisible = false
      this.tagForm = {}
    },
    memberCertificateForm_close() {
      this.memberCertificateFormVisible = false
      this.memberCertificateForm = {}
    },
    memberIdentityForm_close() {
      this.memberIdentityFormVisible = false
      this.memberIdentityForm = {}
    },
    async details_MemberCertificateGet(ids) {
      const { data } = await MemberGet({
        id: ids,
      })
      this.memberCertificateForm = data.response
      console.log(this.memberCertificateForm)
    },
    async details_MemberIdentityGet(ids) {
      const { data } = await MemberGet({
        id: ids,
      })
      this.memberIdentityForm = data.response
      console.log(this.memberIdentityForm)
    },
    //显示发放证书界面
    handleCertificateFormEdit(ids) {
      CertificateId_GetList().then((res) => {
        this.ertificates = res.data.response
      })

      this.details_MemberCertificateGet(ids)
      this.memberCertificateFormVisible = true
      this.dialog_title = '发放证书'
    },
    //分配角色
    handleRoleFormEdit(ids) {
      IdentityId_GetList().then((res) => {
        this.memberIdentityErtificates = res.data.response
      })

      this.details_MemberIdentityGet(ids)
      this.memberIdentityFormVisible = true
      this.dialog_title = '分配培训角色'
    },
    async memberCertificateFormSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let data
          this.editLoading = true
          if (this.dialog_title == '发放证书') {
            data = await GiveMemberCertificate(this.memberCertificateForm)
          }
          if (data.data.success) {
            this.editLoading = false
            this.memberCertificateFormVisible = false
            this.$message({
              message: data.data.msg,
              type: 'success',
            })
            this.getModules_search()
            this.memberCertificateForm = {}
          } else {
            this.editLoading = false
            this.memberCertificateFormVisible = false
            this.$message({
              message: data.data.msg,
              type: 'error',
            })
            // this.getModules_search();
            this.memberCertificateForm = {}
          }
        } else {
          return false
        }
      })
    },
    async memberIdentityFormSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let data
          this.editLoading = true
          if (this.dialog_title == '分配培训角色') {
            data = await GiveMemberIdentity(this.memberIdentityForm)
          }
          if (data.data.success) {
            this.editLoading = false
            this.memberIdentityFormVisible = false
            this.$message({
              message: data.data.msg,
              type: 'success',
            })
            this.getModules_search()
            this.memberIdentityForm = {}
          } else {
            this.editLoading = false
            this.memberIdentityFormVisible = false
            this.$message({
              message: data.data.msg,
              type: 'error',
            })
            // this.getModules_search();
            this.memberIdentityForm = {}
          }
        } else {
          return false
        }
      })
    },

    async details_MemberGet(ids) {
      const { data } = await GetMemberAllTag({
        id: ids,
      })
      this.editForm = {}
      this.editForm = data.response
      var address_list = []
      address_list[0] = await data.response.Province
      address_list[1] = await data.response.City
      address_list[2] = await data.response.Area
      this.editForm.address_list = address_list
      this.isShowAddressInfo = false
      setTimeout(() => {
        this.isShowAddressInfo = true
      }, 500)
      this.GetStoreAccount_fn()
      this.GetStore_fn(true)
      console.log(this.editForm)
    },
    // 查看
    async handleOpen(ids, e) {
      getAllTagListPage().then((res) => {
        this.allTags = res.data.response
      })
      this.details_MemberGet(ids)
      this.DETAIS_IF = true
      this.READ = true
      this.READ_IF = true
      if (e == 'bj') {
        this.editFormVisible_new = true
      } else {
        this.editFormVisible = true
        this.dialog_title = '查看'
      }
    },
    async handleEdit(ids) {
      // this.details_CouponGet(ids);
      this.editFormVisible = true
      this.dialog_title = '编辑'
      this.DETAIS_IF = false
    },
    selectCurrentRow(val) {
      this.currentRow = val
      //此处根据选中的券，判断是否符合导入
      let row = this.currentRow
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    async details_MemberTagGet(ids) {
      const { data } = await MemberGet({
        id: ids,
      })
      this.tagForm = data.response
    },
    //显示编辑标签界面
    handleTagEdit(ids) {
      getTagListPage().then((res) => {
        this.tags = res.data.response
      })
      this.details_MemberTagGet(ids)
      this.tagFormVisible = true
      this.dialog_title = '编辑标签'
    },
    async tagSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let data
          this.editLoading = true
          if (this.dialog_title == '编辑标签') {
            data = await MemberTagPut(this.tagForm)
          }
          if (data.data.success) {
            this.editLoading = false
            this.tagFormVisible = false
            this.$message({
              message: data.data.msg,
              type: 'success',
            })
            this.getModules_search()
            this.tagForm = {}
          }
        } else {
          return false
        }
      })
    },
    //性别显示转换
    formatDateTime: function (row, column) {
      let data = row[column.property]
      if (data == null) {
        return null
      } else {
        return util.formatDate.format(new Date(data), 'yyyy-MM-dd')
      }
    },
    formatStatus: function (row, column) {
      let data = row[column.property]
      if (data == 0) {
        return '审核中'
      } else if (data == 1) {
        return '有效'
      } else if (data == 2) {
        return '阻止'
      } else {
        return null
      }
    },

    handleCurrentChange(val) {
      this.page = val
      this.getModules()
    },
    getModules_search() {
      this.page = 1
      this.getModules()
    },
    ImportUserTagDetail() {
      this.page = 1
      this.getModules()
    },
    // handleChange(file)
    // {
    //   //验证文件格式
    //   const isXlS =
    //     file.type ===
    //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
    //     file.type === "application/vnd.ms-excel";
    //   if (!isXlS) {
    //     this.$message.error("Please upload files in xls and xlsx formats!");
    //     return;
    //   }
    // },
    handlebefore() {
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
    },
    handonerror() {
      // console.log("超时失败");
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      this.$message({
        message: '您的上传已超时，请再次尝试',
        type: 'error',
      })
      loading.close()
    },
    handleSuccess(file, fileLis) {
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      if (file.success == true) {
        loading.close()
        this.QUEST_IF = true
        this.$alert(file.msg, '提示', {
          confirmButtonText: '确定',
        })
      } else if (file.success == false) {
        loading.close()
        this.$alert(file.msg, '提示', {
          confirmButtonText: '确定',
        })
      } else {
        loading.close()
        this.$message({
          message: '您的上传已超时，请再次尝试',
          type: 'error',
        })
      }
    },
    //获取用户列表
    getModules() {
      let para = this.filters
      para.page = this.page
      this.listLoading = true
      MemberGetList(para).then((res) => {
        // console.log(res.data)
        this.total = res.data.response.dataCount
        this.users = res.data.response.data
        this.listLoading = false
        // this.buttonList.forEach(element => {
        //   if(element.Func == 'setCouponSystemPush')
        //   {
        //      this.isShowHide = true;
        //   }
        // });
      })
    },
    //删除
    handleDel(ids) {
      // console.log(ids);
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning',
      })
        .then(() => {
          this.listLoading = true
          //NProgress.start();
          // let para = { id: ids };
          ClassScheduleDelete({
            id: ids,
          }).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false
              return
            }
            this.listLoading = false
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: '删除成功',
                type: 'success',
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }

            this.getModules_search()
          })
        })
        .catch(() => { })
    },
    //审核,阻止，驳回保存
    saveMemberSaveAudit(id, status) {
      var msg = ''
      if (status == -1) {
        msg = '确认驳回吗?'
      } else if (status == 1) {
        msg = '确认通过审核吗?'
      } else if (status == 2) {
        msg = '确认阻止吗?'
      }
      this.$confirm(msg, '提示', {
        type: 'warning',
      })
        .then(() => {
          this.listLoading = true
          MemberSaveAudit({
            id: id,
            status: status,
          }).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false
              return
            }
            this.listLoading = false
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: 'success',
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }

            this.getModules_search()
          })
        })
        .catch(() => { })
    },
  },
  async mounted() {
    // let roleNames = JSON.parse(localStorage.getItem("roleNames"));
    this.getModules()
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    console.log(this.token)
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : []
    this.buttonList = getButtonList(this.$route.path, routers)
    IdentityId_GetList().then((res) => {
      this.memberIdentityErtificates = res.data.response
    })
    const { data } = await GetStoreAre()
    this.store_are_list = data.response
  },
}
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>
<style>
.el-table .cell {
  text-align: center !important;
}

.el-button--primary {
  background-color: #409eff !important;
  border-color: #409eff !important;
}

/* 
  .el-link.el-link--primary:hover {
    color: #409eff !important;
  } */

.el-link.el-link {
  color: #409eff !important;
}

.el-link.is-underline:hover:after {
  border-bottom: 1px solid #409eff !important;
}

.el-link.el-link--default:after,
.el-link.el-link--primary.is-underline:hover:after,
.el-link.el-link--primary:after {
  border-color: #409eff !important;
}

.el-pager li.active {
  color: #409eff !important;
}
</style>
